import  firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyCI76VOOwrXBqEXMosNgGnwQS0SwPOqMdE",
   authDomain: "erichawkinson-39a06.firebaseapp.com",
   storageBucket: "my-hometown-project-dev",
   projectId: "erichawkinson-39a06",

};

firebase.initializeApp(firebaseConfig);

export const firebaseAdmin = firebase.initializeApp(firebaseConfig, 'ADMIN');

export default firebase;
